import { TabProxy } from "encampy";

export async function automateKSTier2OnlineLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input[name='UserID']", { timeout: 10000 });

  // Type in the username
  await tab.type("input[name='UserID']", username);

  // Type in the password
  await tab.type("input[name='Password']", password);

  // Click Submit (image button)
  await tab.click("input[name='image'][alt='Submit!']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
